import React, { useState, useEffect } from "react";
import Headline4 from "../../../../components/headings/Headline4";
import Styles from "../../styles.module.scss";
import Uploader from '../../../../components/uploader';
import {extractResume} from './services'
import AWS from 'aws-sdk';
import NotificationAlert from "../../../../components/notification";
import {  postAPI, uploadApi } from '../../../../api/apis'
import mixpanelData from "../../../../utils/mixpanel";
import { REACT_APP_CANDIDATE_FREELANCER } from "../../../../utils/common";

interface Props {
  loginId: string | null
  getUserDetails: any
  resume: string | null
  resumeError: string;
}

// const S3_BUCKET ='ellow-dev-dashboard-upload';
// const REGION ='ap-south-1';

AWS.config.update({
  accessKeyId: 'AKIAU2WIJEWHLXODZCYH',
  secretAccessKey: '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'
})

// const myBucket = new AWS.S3({
//   params: { Bucket: S3_BUCKET},
//   region: REGION,

// })


const Resume: React.FC<Props> = ({
  loginId,
  getUserDetails,
  resume,
  resumeError
}) => {

const { v4: uuidv4 } = require('uuid')
const [ upload, setUpload] = useState<boolean>(false)
const [ error, setError] = useState<boolean>(false)
const [ message, setMessage] = useState<string>('')
const [notification, setNotification] = useState<boolean>(false)
const [resumeName, setResumeName] = useState<string | null>(null)
const [errorMessage, setErrorMessage] = useState<string>('')
const email = localStorage.getItem('Email') || ''
const toastMessage = ''
  
useEffect(() => {
  if (resume){  
    setResumeName(resume.slice(36, resume.length))  
  }
   
}, [resume])

useEffect(() => {
  if (resumeError && resumeError !== '') {
   setErrorMessage(resumeError)
 }
}, [resumeError])
  
const uploadFile = (e: any) => {

  //<< file upload using presignedurl>>//
  let fileExtension = e.target.files[0].name.split('.').pop()
  if(fileExtension === 'pdf' || fileExtension === 'doc' || fileExtension === 'docx'){

  // let formData = new FormData();
  // formData.append("file", e.target.files[0]);
  let file = e.target.files[0]
  let type = file.type


  let fileName = uuidv4() + e.target.files[0].name.replace(/ /g, ""); 

  let value = {
    "action":"putObject",
    "filename":fileName
  }
  postAPI( REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url',value).then((data) => {
  if(data) {
    setMessage('This might take a while, We are trying to extract most of the information to make your life easier.')
  }
   let signedUrl = data.url;
      //<< upload file to s3 using the signedurl>>//
      uploadApi(signedUrl, file, type).then((response: any) => {
      setError(false)
      let data = {
        loginId: '',
        fileName: fileName,
        submittedBy: 'FREELANCER',
        sourcedBy: "REFERRAL",
        userLoginId: loginId
      }
      //<< extrect details of the uploaded resume>>//
      extractResume(data).then((response) => {          
          if (response && response.status === 1){    
            setError(false)
            let id = response.data[0].login_id
            localStorage.setItem('candidateLoginId', response.data[0].login_id)
            getUserDetails(id) 
            setUpload(true);
            setResumeName(fileName)
            setMessage('File Uploaded successfully')
            mixpanelData('New MWP - Refer and Earn Resume Upload', {
              "distinct_id": email,
              'Candidate loginid': loginId,
              "Resume name": fileName ,
              "Candidate name": response.data[0].profile_metadata.firstName + " " + response.data[0].profile_metadata.lastName
            })
          }else {      
            setError(true)
            setMessage("Please try with a non-existing email id!")   
          } 
        }).catch((err)=>{   
          setError(true)
          setMessage(err.message)   
        });
       
     })
    }) 
  }
  else {
  setMessage("Please upload pdf or doc file")
  setError(true)
  setUpload(false)
 }

  }



const onClose = () => {
  setNotification(false)
 }

  return (
      <div className={Styles.resumeWrapper}>
        <div className={Styles.resumeHead}>
          <Headline4>Resume</Headline4>
        </div>
        {notification && <NotificationAlert onClose={onClose } closable={true} >
        {toastMessage}
        </NotificationAlert> }
        <div className="form-group">
          <label className="lablel">
          Resume is the most important key to impress the recruiter and land your dream job.
          </label>
          {/* <Uploader batch={false}
            multiple={false}
            defaultFiles={[]}
            withCredentials={false}
            saveUrl={"https://demos.telerik.com/kendo-ui/service-v4/upload/save"}
            removeUrl={"https://demos.telerik.com/kendo-ui/service-v4/upload/remove"}
            onAdd={uploadFile}
            /> */}
            <Uploader uploadFile={uploadFile} upload={upload} error={error} message={message} resume={resumeName} errorMessage={errorMessage} />
        </div>
      </div>
  );
}
export default Resume;
